import { createSlice } from "@reduxjs/toolkit";
export const finishedTilesArraySlice = createSlice({
  name: "finishedTilesArray",
  initialState: {
    array: [],
  },
  reducers: {
    setArray: (state, action) => {
      state.array = action.payload;
    },
  },
});

export const { setArray } = finishedTilesArraySlice.actions;

export default finishedTilesArraySlice.reducer;
